import {Injectable} from "@angular/core";
import {IAlertControllerCreate} from "@shared/interfaces/alert-controller-create.interface";
import {CoreErrorHandlerBaseService} from "@core/services/error-handler-base/core-error-handler-base.service";

@Injectable({
  providedIn: 'root'
})
export class SharedResetPasswordErrorHandlerService extends CoreErrorHandlerBaseService {

  override _formatAlertFor404(status: number): IAlertControllerCreate {
    this._errorText = this._translateService.instant("GENERAL.ENDPOINTS.ONE.ERRORS.ERROR");
    return {
      header: '',
      subHeader: this._translateService.instant("LOGIN.RESET_PASSWORD.ERRORS.404"),
      message: '',
      buttons: [
        { text: 'OK' }
      ]
    };
  }
}
